import apiClient from './apiClient';

class SubscriptionService {
  constructor() {
    this.pollingInterval = null;
    this.pollingIntervalMs = 10000; // 5 minutes
    // this.pollingIntervalMs = 5 * 60 * 1000; // 5 minutes
    this.isPolling = false;
  }

  startPolling(authStore) {
    // Only start polling if not already polling and user is on a paid plan
    if (this.isPolling || !authStore.user?.subscription?.type || authStore.user.subscription.type === 'free') {
      return;
    }

    this.isPolling = true;
    console.log('Starting subscription polling...');

    // Poll immediately on start
    this.pollSubscription(authStore);

    // Set up interval for regular polling
    this.pollingInterval = setInterval(() => {
      // Double-check that we should still be polling
      if (this.shouldPoll(authStore)) {
        this.pollSubscription(authStore);
      } else {
        console.log('User no longer eligible for polling, stopping...');
        this.stopPolling();
      }
    }, this.pollingIntervalMs);
  }

  stopPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
    this.isPolling = false;
    console.log('Stopped subscription polling');
  }

  async pollSubscription(authStore) {
    try {
      const response = await apiClient.getSubscriptionStatus();
      
      if (response.status === 'success') {
        console.log(response.data);
        const { subscription, isExpired } = response.data;
        
        // Update only the subscription without triggering polling restart
        authStore.updateSubscriptionOnly(subscription);
        
        // If subscription expired, stop polling since user is now on free plan
        if (isExpired) {
          console.log('Subscription expired, stopping polling');
          this.stopPolling();
        }
      }
    } catch (error) {
      console.error('Error polling subscription status:', error);
      // Don't stop polling on error, just log it and continue
    }
  }

  // Check if user should have polling enabled
  // Only poll for users on paid plans (pro), regardless of autoRenew status
  shouldPoll(authStore) {
    return authStore.status.loggedIn && 
           authStore.user?.subscription?.type && 
           authStore.user.subscription.type === 'pro';
  }

  // Restart polling if user subscription changes
  restartPolling(authStore) {
    // Prevent rapid restarts
    if (this.isPolling && this.shouldPoll(authStore)) {
      return; // Already polling and should continue
    }
    
    this.stopPolling();
    
    if (this.shouldPoll(authStore)) {
      this.startPolling(authStore);
    }
  }
}

// Export a singleton instance
export default new SubscriptionService();
